// This component is an example on how to work with redux. Delete in the future

import { useDispatch, useSelector } from 'react-redux';
import {
  decrement,
  increment,
  incrementByAmount,
  incrementAsync,
  clear,
} from '../../state/counter/counterSlice';

const Counter = () => {
  const count = useSelector((state) => state.counter.value);
  const dispatch = useDispatch();

  return (
    <div>
      <h2>{count}</h2>
      <div>
        <button onClick={() => dispatch(increment())}>Increment</button>
        <button onClick={() => dispatch(incrementByAmount(5))}>
          Increment By Amount
        </button>
        <button onClick={() => dispatch(incrementAsync(10))}>
          Increment Async
        </button>
        <button onClick={() => dispatch(decrement())}>Decrement</button>
        <button onClick={() => dispatch(clear())}>Clear</button>
      </div>
    </div>
  );
};

export default Counter;
